var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown_content",domProps:{"innerHTML":_vm._s(_vm.md_to_html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }